import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import { useEffect } from 'react';

export default function BrentwoodPage() {
  useEffect(() => {
    document.title = 'Brentwood Bollard Installation | Security Bollards Essex';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Premium bollard installation in Brentwood, Essex. Telescopic, fold-down & electric bollards for high-value properties. Call +44 7834 858178');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-16">
        <section className="relative bg-gradient-to-br from-black via-gray-900 to-black py-24 overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
          <div className="container mx-auto px-4 relative z-10">
            <div className="max-w-4xl mx-auto text-center text-white">
              <div className="inline-flex items-center space-x-2 bg-yellow-500/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
                <i className="ri-map-pin-line text-yellow-500"></i>
                <span className="text-yellow-500 font-semibold">Brentwood, Essex</span>
              </div>
              <h1 className="text-5xl md:text-6xl font-black mb-6 leading-tight">
                Bollard Installation in <span className="text-yellow-500">Brentwood</span>
              </h1>
              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Premium bollard installation services for Brentwood's high-value properties. Serving 77,000+ 
                residents with sophisticated security bollard solutions for residential and commercial estates.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="tel:+447834858178" className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-phone-line text-xl"></i>
                  <span>Call +44 7834 858178</span>
                </a>
                <a href="/quote" className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-file-list-line text-xl"></i>
                  <span>Get Free Quote</span>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-4">
                Premium Bollard Solutions for <span className="text-yellow-500">Brentwood</span>
              </h2>
              <p className="text-xl text-gray-600 max-w-3xl mx-auto">
                Bespoke bollard installation services for Brentwood's prestigious properties, combining 
                superior security with aesthetic appeal.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300">
                <div className="w-16 h-16 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-arrow-up-down-line text-yellow-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Telescopic Bollards</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Elegant retractable bollards perfect for Brentwood's luxury properties. Discreet 
                  security that maintains your property's premium appearance.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Premium finish options</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Smooth operation</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Aesthetic design</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300">
                <div className="w-16 h-16 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-arrow-down-circle-line text-yellow-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Fold Down Bollards</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  High-quality fold-down bollards for Brentwood commercial properties. Robust 
                  protection with refined appearance.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Premium construction</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Secure locking</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Professional finish</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white border border-gray-200 rounded-xl p-8 hover:shadow-xl hover:border-yellow-500/50 transition-all duration-300">
                <div className="w-16 h-16 bg-yellow-500/10 rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-flashlight-line text-yellow-500 text-3xl"></i>
                </div>
                <h3 className="text-2xl font-bold mb-4">Electric Bollards</h3>
                <p className="text-gray-600 leading-relaxed mb-4">
                  Luxury automated bollards for Brentwood's exclusive properties. Sophisticated 
                  remote control operation with premium features.
                </p>
                <ul className="space-y-2 text-gray-600">
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Smart control systems</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Silent operation</span>
                  </li>
                  <li className="flex items-start space-x-2">
                    <i className="ri-check-line text-yellow-500 mt-1"></i>
                    <span>Integrated lighting</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-gray-50">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-4">
                Why Choose Us for <span className="text-yellow-500">Brentwood</span>?
              </h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-home-smile-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Premium Service</h3>
                <p className="text-gray-600">
                  Specialized in high-value Brentwood properties with bespoke solutions
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-time-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Professional Service</h3>
                <p className="text-gray-600">
                  Discreet and efficient installation with minimal disruption
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-shield-check-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Superior Quality</h3>
                <p className="text-gray-600">
                  Premium materials with extended warranty coverage
                </p>
              </div>

              <div className="text-center">
                <div className="w-20 h-20 bg-yellow-500/10 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-customer-service-line text-yellow-500 text-4xl"></i>
                </div>
                <h3 className="text-xl font-bold mb-3">Dedicated Support</h3>
                <p className="text-gray-600">
                  Priority maintenance services for Brentwood clients
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="text-center mb-16">
              <h2 className="text-4xl md:text-5xl font-black mb-4">
                Brentwood Areas We <span className="text-yellow-500">Serve</span>
              </h2>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
              {[
                'Brentwood Town',
                'Shenfield',
                'Warley',
                'Hutton',
                'Ingatestone',
                'Mountnessing',
                'West Horndon',
                'Herongate'
              ].map((area, index) => (
                <div key={index} className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center hover:border-yellow-500 hover:bg-yellow-500/5 transition-all cursor-pointer">
                  <i className="ri-map-pin-line text-yellow-500 text-xl mb-2"></i>
                  <p className="font-semibold text-gray-800">{area}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="py-20 bg-gradient-to-br from-black to-gray-900">
          <div className="container mx-auto px-4">
            <div className="max-w-4xl mx-auto text-center text-white">
              <h2 className="text-4xl md:text-5xl font-black mb-6">
                Secure Your <span className="text-yellow-500">Brentwood</span> Property
              </h2>
              <p className="text-xl text-gray-300 mb-8">
                Get a free consultation for premium bollard installation in Brentwood. Our expert team 
                provides bespoke security solutions for your property.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <a href="tel:+447834858178" className="bg-yellow-500 text-black px-8 py-4 rounded-lg font-bold hover:bg-yellow-400 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-phone-line text-xl"></i>
                  <span>Call +44 7834 858178</span>
                </a>
                <a href="/quote" className="bg-white/10 backdrop-blur-sm text-white border border-white/20 px-8 py-4 rounded-lg font-bold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center space-x-2">
                  <i className="ri-file-list-line text-xl"></i>
                  <span>Request Free Quote</span>
                </a>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}